import React, {useEffect, useState} from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Form from 'components/Form';
import GridBlock from 'components/GridBlock';
import TextInput from 'components/TextInput';
import Tr from 'translations/Translations';
import RadioList from './RadioList';
import DoubleButton from '../components/DoubleButton';
import * as Yup from 'yup'
// import ValidationShema from 'constants/ValidationShema'
import {connect} from 'react-redux'
import Loading from 'components/Loading';
import useId from 'hooks/useId';
import countItems from './libs/countItems';
import CpvService from "../../../services/CpvService";

const style = theme => ({
    root: {},
    loading: {
        height: 100,
    }
})

function SelectForm(
    {
        classes,
        onSubmit,
        onCancel,
        formSubmit,
        initCPVValues,
        multiple
    }) {
    const formId = useId();
    const [cpvList, setCpvList] = useState(null)
    const countCpvList = countItems(cpvList)

    const handleSubmit = ({search, ...values}) => {
        onSubmit(values)
    }

    const handleSave = () => {
        formSubmit[formId]();
    }


    useEffect(() => {
        CpvService.get().then((resp) => setCpvList(resp));
    }, []);

    return (
        <>
            {!cpvList ?
                <Loading/>
                :
                <Form
                    initialValues={{
                        search: '',
                        ...initCPVValues,
                    }}
                    id={formId}
                    onSubmit={handleSubmit}
                    validationSchema={Yup.object().shape({})}
                >
                    {(formikProps) => (
                        <GridBlock column>
                            <TextInput
                                label={Tr('search_label_3')}
                                id='search'
                                formikProps={formikProps}
                            />
                            {Boolean(cpvList) ?
                                <RadioList
                                    formikProps={formikProps}
                                    items={cpvList}
                                    countItems={countCpvList}
                                    multiple={multiple}
                                    handleSave={handleSave}
                                />
                                :
                                <Loading className={classes.loading}
                                />}
                            <GridBlock justify='flex-end'>
                                <DoubleButton
                                    labelFirst={Tr('cancel')}
                                    labelSecond={Tr('save')}
                                    onClickFirst={onCancel}
                                    onClickSecond={handleSave}
                                    disabledSecond={!multiple}
                                />
                            </GridBlock>
                        </GridBlock>
                    )}
                </Form>
            }
        </>
    )
}

SelectForm.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(withStyles(style)(SelectForm));
